import { Convention } from "../../../concepts/objects";
import { Physical } from "../../canvas/entities/Physical";

export interface Playable extends Physical { }
export const Playable = new Convention<Playable>('Playable');